import React from 'react';
import {ReactComponent as Circle} from '../../../assets/circle_plus.svg';
import cx from 'classnames';

type AddNewLocationButtionProps = {
  onClick: () => void;
  disabled?: boolean;
};

function AddNewLocationButton({
  onClick,
  disabled = false,
}: AddNewLocationButtionProps) {
  return (
    <div
      className={
        'flex items-center justify-center w-[435px] h-[275px] border border-[#d5dadd]'
      }
    >
      <button
        disabled={disabled}
        onClick={onClick}
        className={
          'border-0 outline-none bg-transparent flex flex-col items-center gap-[11px]'
        }
        data-test-id={'add-gps-btn'}
      >
        <Circle
          className={cx('w-10 h-10', disabled ? 'opacity-50' : 'opacity-100')}
        />
        新增GPS
      </button>
    </div>
  );
}

export default AddNewLocationButton;
